
<div class="flow-sidebar-item">
	<slot />
</div>
